<template>
<el-row :gutter="15" style="height: 100%;padding: 0 10px;" class="business-form">
    <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title">添加人员信息
            <span class="info_btn">
                <i class="el-icon-minus"></i>
                <i class="el-icon-close" @click.stop="close"></i>
            </span>
        </div>
        <div class="add_info_tab">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本信息" name="1">
                    <div class="basic_content">
                     <el-form ref="form" :model="form" :rules="rules2" :inline="true" label-width="90px">
                        <div class="basic_info">
                            <div class="basic_info_div">
                                <el-upload
                                        action="http://127.0.0.1:8000/api/UploadFile/"
                                        list-type="picture-card"
                                        :auto-upload="false"
                                        :on-change="OnChange"
                                        :on-remove="OnRemove"
                                        :on-preview="handlePictureCardPreview"
                                        :before-remove="beforeRemove"
                                        >
                                        <i class="el-icon-plus"></i>
                                 </el-upload>
                                  <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                  </el-dialog>



                            </div>
                            <div class="basic_info_div1">

                                    <!-- <div class="form-div" style="color:red;font-size:30px;">
                                        <el-form-item label="姓名" prop="name">
                                             <el-input v-model="form.name"></el-input>
                                        </el-form-item>*
                                        <el-form-item label="性别">
                                            <el-select v-model="form.sex">
                                                <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="身份证号" prop="idNumber">
                                            <el-input v-model="form.idNumber" type="idNumber" autocomplete="off" @blur="findIdNumber($event)"></el-input>
                                        </el-form-item>*
                                    </div>
                                    <div class="form-div" style="color:red;font-size:30px;">
                                        <el-form-item label="出生年月" >
                                            <el-input v-model="form.birthday"></el-input>
                                        </el-form-item>
                                       <el-form-item label="年龄">
                                            <el-input v-model="form.age"></el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号码" prop="phone">
                                            <el-input v-model="form.phone" type="phone" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </div>
                                    <div class="form-div" style="margin-top: 15px">
                                        <el-form-item label="民族">
                                            <el-input v-model="form.nation"></el-input>
                                        </el-form-item>
                                        <el-form-item label="婚姻状态">
                                            <el-select v-model="form.marriageStatus">
                                                <el-option label="未婚" value="1">未婚</el-option>
                                                <el-option label="已婚" value="2">已婚</el-option>
                                                <el-option label="离婚" value="3">离婚</el-option>
                                                <el-option label="丧偶" value="4">丧偶</el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="生活区域">
                                            <el-select v-model="form.lifeAreas">
                                                <el-option label="城市" value="1">城市</el-option>
                                                <el-option label="农村" value="2">农村</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="form-div" style="margin-top: 15px">
                                        <el-form-item label="家庭号码">
                                            <el-input v-model="form.familyPhone"></el-input>
                                        </el-form-item>
                                        <el-form-item label="用户类型" prop="type">
                                            <el-select v-model="form.type">
                                                <el-option label="普通客户" value="1">普通客户</el-option>
                                                <el-option label="老干服务对象" value="4">老干服务对象</el-option>
                                                <el-option label="政府援助客户" value="6">政府援助客户</el-option>
                                                <el-option label="D类援助客户" value="8">D类援助客户</el-option>
                                                 <el-option label="残联服务对象" value="3">残联服务对象</el-option>
                                            </el-select>
                                        </el-form-item>
                                         <el-form-item label="区域名称" prop="addressId">
                                                <el-select class="fl form-input" v-model="form.addressId"  @click.native="selectAddressName()" @change="changeValue" placeholder="请选择区域" >
                                                        <el-option v-for="item in options" :label="item.addressName" :key="item.id" :value="item.id"> </el-option>
                                                </el-select>
                                             </el-form-item>
                                    </div> -->
                                    <div class="form-div" style="color:red;font-size:30px;">
                                        <el-form-item label="姓名" prop="name">
                                             <el-input v-model="form.name"></el-input>
                                        </el-form-item>*
                                        <el-form-item label="性别">
                                            <el-select v-model="form.sex">
                                                <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="身份证号" prop="idNumber" :rules="[{required: true, message: '请填写证件号码', trigger: 'blur' },
                                            {pattern:/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/, message: '证件号码格式有误！', trigger: 'blur'}]">
                                            <el-input v-model="form.idNumber" type="idNumber" autocomplete="off" @blur="findIdNumber($event)"></el-input>
                                        </el-form-item>*
                                    </div>
                                    <div class="form-div" style="margin-top: 15px;color:red;font-size:30px;">
                                        <el-form-item label="出生年月" >
                                            <el-input v-model="form.birthday"></el-input>
                                        </el-form-item>
                                       <el-form-item label="年龄">
                                            <el-input v-model="form.age"></el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号码" prop="phone">
                                            <el-input v-model="form.phone" type="phone" autocomplete="off"></el-input>
                                        </el-form-item>*
                                    </div>
                                    <div class="form-div" style="margin-top: 15px">
                                        <el-form-item label="民族">
                                            <el-input v-model="form.nation"></el-input>
                                        </el-form-item>
                                        <el-form-item label="婚姻状态">
                                            <el-select v-model="form.marriageStatus">
                                                <el-option label="未婚" value="1">未婚</el-option>
                                                <el-option label="已婚" value="2">已婚</el-option>
                                                <el-option label="离婚" value="3">离婚</el-option>
                                                <el-option label="丧偶" value="4">丧偶</el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="生活区域">
                                            <el-select v-model="form.lifeAreas">
                                                <el-option label="城市" value="1">城市</el-option>
                                                <el-option label="农村" value="2">农村</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                    <div class="form-div" style="margin-top: 15px">
                                        <el-form-item label="家庭号码">
                                            <el-input v-model="form.familyPhone"></el-input>
                                        </el-form-item>
                                        <el-form-item label="用户类型" prop="type">
                                            <el-select v-model="form.type">
                                                <el-option label="普通客户" value="1">普通客户</el-option>
                                                <el-option label="老干服务对象" value="4">老干服务对象</el-option>
                                                <el-option label="政府援助客户" value="6">政府援助客户</el-option>
                                                <el-option label="D类援助客户" value="8">D类援助客户</el-option>
                                                 <el-option label="残联服务对象" value="3">残联服务对象</el-option>
                                                  <el-option label="文明办服务对象" value="10">文明办服务对象</el-option>
                                            </el-select>
                                        </el-form-item>
                                         <el-form-item label="区域名称" prop="addressId">
                                                <el-select class="fl form-input" v-model="form.addressId"  @click.native="selectAddressName()" @change="changeValue" placeholder="请选择区域" >
                                                        <el-option v-for="item in options" :label="item.addressName" :key="item.id" :value="item.id"> </el-option>
                                                </el-select>
                                             </el-form-item>
                                    </div>
                            </div>
                        </div>
                        <div class="basic_info_1">
                                <div class="form-div">
                                    <el-form-item label="居住情况">
                                        <el-radio-group v-model="form.juzhuCommunity" style="margin-top: 15px">
                                            <el-radio  label=4>独自居住</el-radio>
                                            <el-radio  label=5>与配偶居住</el-radio>
                                            <el-radio label=3>与子女居住</el-radio>
                                            <el-radio  label=6>其他</el-radio>
                                        </el-radio-group>
                                       <el-input v-model="form.otherJuzhuCommunity"></el-input>
                                    </el-form-item>
                                    <el-form-item label="经济来源">
                                        <el-checkbox-group v-model="economicSource">
                                            <el-checkbox  label=0 >养老金</el-checkbox>
                                            <el-checkbox  label=1 >子女供养</el-checkbox>
                                            <el-checkbox  label=2 >救济优抚</el-checkbox>
                                            <el-checkbox  label=3 >兼职</el-checkbox>
                                            <el-checkbox  label=4>其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherEconomicSource"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="证号">
                                        <el-input v-model="form.certificateNumber"></el-input>
                                        <el-checkbox-group v-model="certificateType">
                                            <el-checkbox  label=0>低保证金</el-checkbox>
                                            <el-checkbox   label=1>优抚证</el-checkbox>
                                            <el-checkbox  label=2>失独证</el-checkbox>
                                            <el-checkbox   label=3>其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherCertificateType"></el-input>
                                    </el-form-item>
                                    <el-form-item label="离退休前职务职称" class="form-label">
                                        <el-input v-model="form.postTitle"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="个人喜好" class="form-like">
                                        <el-checkbox-group v-model="personalHobby">
                                            <el-checkbox label=0>棋牌</el-checkbox>
                                            <el-checkbox label=1>舞蹈</el-checkbox>
                                            <el-checkbox label=2>诗词</el-checkbox>
                                            <el-checkbox label=3>戏曲</el-checkbox>
                                            <el-checkbox label=4>钓鱼</el-checkbox>
                                            <el-checkbox label=5>书画</el-checkbox>
                                            <el-checkbox label=6>收藏</el-checkbox>
                                            <el-checkbox label=7>摄影</el-checkbox>
                                            <el-checkbox label=8>旅游</el-checkbox>
                                            <el-checkbox label=9>唱歌</el-checkbox>
                                            <el-checkbox label=10>其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherPersonalHobby"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="市" class="form-input">
                                       <el-select class="fl form-input" v-model="form.city"  @click.native="selectAddressShi()" @change="changeValue" placeholder="请选择市" >
                                            <el-option v-for="item in options" :label="item.addressName" :key="item.id" :value="item.id"> </el-option>
                                       </el-select>
                                    </el-form-item>
                                    <el-form-item label="区" class="form-input">
                                        <el-select class="fl form-input" v-model="form.zone"  @click.native="selectAddressQu()" @change="quValue" placeholder="请选择区" >
                                            <el-option v-for="item in options" :label="item.addressName" :key="item.id" :value="item.id"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="街道" class="form-input">
                                         <el-select class="fl form-input"  v-model="form.street"  @click.native="selectAddressJd()" @change="jdValue" placeholder="请选择街道" >
                                            <el-option v-for="item in options" :label="item.addressName" :key="item.id" :value="item.id"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="社区" class="form-input">
                                       <el-select class="fl form-input"  v-model="form.shequ"  @click.native="selectAddressSq()" @change="sqValue" placeholder="请选择社区" >
                                            <el-option v-for="item in options" :label="item.addressName" :key="item.id" :value="item.id"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                 <div class="form-div form-flex" style="color:red;font-size:30px;">
                                    <el-form-item label="详细地址" prop ="address">
                                        <el-input v-model="form.address"></el-input>
                                    </el-form-item>*
                                </div>
                                <div class="form-div form-flex" style="margin-top: 15px;color:red;font-size:30px;">
                                    <el-form-item label="居住地址" prop="currentAddress">
                                        <el-input v-model="form.currentAddress"></el-input>
                                    </el-form-item>*
                                </div>
                                <div class="form-div form-flex" style="margin-top: 15px;">
                                    <el-form-item label="附加信息">
                                        <el-input v-model="form.moreinfo" :rows="2" type="textarea"></el-input>
                                    </el-form-item>
                                </div>
                                <!-- <div class="form-div form-flex">
                                    <el-form-item label="详细地址">
                                        <el-input v-model="form.address"></el-input>
                                    </el-form-item>
                                    <el-form-item label="居住地址">
                                        <el-input v-model="form.currentAddress"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div form-flex">
                                    <el-form-item label="附加信息">
                                        <el-input v-model="form.moreinfo" :rows="2" type="textarea"></el-input>
                                    </el-form-item>
                                </div> -->
                                <div class="form-div">
                                    <el-form-item label="照片上传">
                                        <div style="display:none;">
                                            <input @change="fileChange2" id="dictUpload2" type="file" name="file" />
                                        </div>
                                        <label for="dictUpload2" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </el-form-item>
                                </div>
                        </div>
                        <div class="basic_info_2">
                            <div class="basic_title">居家养老信息</div>
                                <div class="form-div">
                                    <el-form-item label="老人类别">
                                        <el-checkbox-group v-model="minzhengIndex">
                                            <el-checkbox label=0 >特困老人</el-checkbox>
                                            <el-checkbox label=1 >低保老人</el-checkbox>
                                            <el-checkbox label=2 >建档立卡贫困老人</el-checkbox>
                                            <el-checkbox label=3 >优抚对象</el-checkbox>
                                            <el-checkbox label=4 >失独老人</el-checkbox>
                                            <el-checkbox label=5 >残疾老人</el-checkbox>
                                            <el-checkbox label=9 >计划生育特殊家庭成员</el-checkbox>
                                            <el-checkbox label=7>空巢老人</el-checkbox>
                                            <el-checkbox label=8 >农村留守老人</el-checkbox>
                                            <el-checkbox label=6 >其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form.otherMinzhengIndex"></el-input>
                                    </el-form-item>
                                    <el-form-item label="政府购买对象">
                                        <el-checkbox-group v-model="governmentTarget">
                                             <el-checkbox label="0">70岁以上享受城乡低保待遇</el-checkbox>
                                            <el-checkbox label="1">80岁以上重点优抚对象</el-checkbox>
                                            <el-checkbox label="2">80岁以上失独老人</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                    <el-form-item label="是否为政府购买对象">
                                        <el-checkbox-group v-model="government">
                                            <el-checkbox label="0">是</el-checkbox>
                                            <el-checkbox label="1">否</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                    <el-form-item label="期望养老模式">
                                        <el-checkbox-group v-model="pattern">
                                            <el-checkbox label="0">居家养老</el-checkbox>
                                            <el-checkbox label="1">社区养老</el-checkbox>
                                            <el-checkbox label="2">机构养老</el-checkbox>
                                            <el-checkbox label="3">其他</el-checkbox>
                                        </el-checkbox-group>
                                        <el-input v-model="form2.otherPattern"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="期望的服务">
                                        <el-checkbox-group v-model="desiredService">
                                            <el-checkbox label="0">家政服务</el-checkbox>
                                            <el-checkbox label="1">生活照料</el-checkbox>
                                            <el-checkbox label="2">健康咨询</el-checkbox>
                                            <el-checkbox label="3">精神慰藉</el-checkbox>
                                            <el-checkbox label="4">陪同就医</el-checkbox>
                                            <el-checkbox label="5">换季服务</el-checkbox>
                                            <el-checkbox label="6">助浴服务</el-checkbox>
                                            <el-checkbox label="7">助残服务</el-checkbox>
                                            <el-checkbox label="8">助洁服务</el-checkbox>
                                            <el-checkbox label="9">助餐服务</el-checkbox>
                                            <el-checkbox label="10">助行服务</el-checkbox>
                                            <el-checkbox label="11">定制服务</el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                </div>

                        </div>
                        <div class="basic_info_3">
                            <div class="basic_info_left">
                                <div class="basic_title">监护人或紧急联系人信息</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>志愿者</label>
                                             <el-input class="fl form-input" autocomplete="off" readonly v-model="volunteer1Name" @click.native="inputClick"></el-input>
                                            <div class="table-expand" v-if='tableExpand'>
                                                <div class="table-search">
                                                    <label class="fl form-label">名称</label>
                                                    <el-input class="fl form-input" v-model="search"></el-input>
                                                    <el-button type="primary" size="small" icon="el-icon-search"  @click.native="inputClick">过滤</el-button>
                                                    <el-button size="medium" type="danger"  @click.native="inputClosekVolunteer1">关闭</el-button>
                                                </div>
                                                <el-table class="form-table"
                                                    :data="tableData"
                                                    stripe
                                                    tooltip-effect="dark"
                                                    style="width: 100%">
                                                    <el-table-column
                                                        fixed
                                                        prop="date"
                                                        label="序号"
                                                        width="50">
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="name"
                                                        label="志愿者姓名"
                                                        show-overflow-tooltip>
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="telephone"
                                                        show-overflow-tooltip
                                                        label="手机号码">
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="opt"
                                                        label="操作对象">
                                                        <template slot-scope="scope">
                                                            <i class="el-icon el-icon-1" title="选择" @click.stop="changeVolunteer1(scope.row.id)"></i>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <Paginationmini :pageConfig="pageConfig3" @currentPage="currentChange3" @pageSize="pageSizeChange3"></Paginationmini>
                                            </div>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>志愿者电话</label>
                                            <el-input v-model="VolunteerPhone1"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>志愿者</label>
                                             <el-input class="fl form-input" autocomplete="off" readonly v-model="volunteer2Name" @click.native="inputClick2"></el-input>
                                            <div class="table-expand" v-if='tableExpand2'>
                                                <div class="table-search">
                                                    <label class="fl form-label">名称</label>
                                                    <el-input class="fl form-input" v-model="search"></el-input>
                                                    <el-button type="primary" size="small" icon="el-icon-search"  @click.native="inputClick2">过滤</el-button>
                                                    <el-button size="medium" type="danger"  @click.native="inputClosekVolunteer2">关闭</el-button>
                                                </div>
                                                <el-table class="form-table"
                                                    :data="tableData"
                                                    stripe
                                                    tooltip-effect="dark"
                                                    style="width: 100%">
                                                    <el-table-column
                                                        fixed
                                                        prop="date"
                                                        label="序号"
                                                        width="50">
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="name"
                                                        label="志愿者姓名"
                                                        show-overflow-tooltip>
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="telephone"
                                                        show-overflow-tooltip
                                                        label="手机号码">
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="opt"
                                                        label="操作对象">
                                                        <template slot-scope="scope">
                                                            <i class="el-icon el-icon-1" title="选择" @click.stop="changeVolunteer2(scope.row.id)"></i>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <Paginationmini :pageConfig="pageConfig3" @currentPage="currentChange4" @pageSize="pageSizeChange4"></Paginationmini>
                                            </div>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>志愿者电话</label>
                                            <el-input v-model="VolunteerPhone2"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>志愿者</label>
                                             <el-input class="fl form-input" autocomplete="off" readonly v-model="volunteer3Name" @click.native="inputClick3"></el-input>
                                            <div class="table-expand" v-if='tableExpand3'>
                                                <div class="table-search">
                                                    <label class="fl form-label">名称</label>
                                                    <el-input class="fl form-input" v-model="search"></el-input>
                                                    <el-button type="primary" size="small" icon="el-icon-search"  @click.native="inputClick3">过滤</el-button>
                                                    <el-button size="medium" type="danger"  @click.native="inputClosekVolunteer3">关闭</el-button>
                                                </div>
                                                <el-table class="form-table"
                                                    :data="tableData"
                                                    stripe
                                                    tooltip-effect="dark"
                                                    style="width: 100%">
                                                    <el-table-column
                                                        fixed
                                                        prop="date"
                                                        label="序号"
                                                        width="50">
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="name"
                                                        label="志愿者姓名"
                                                        show-overflow-tooltip>
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="telephone"
                                                        show-overflow-tooltip
                                                        label="手机号码">
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="opt"
                                                        label="操作对象">
                                                        <template slot-scope="scope">
                                                            <i class="el-icon el-icon-1" title="选择" @click.stop="changeVolunteer3(scope.row.id)"></i>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <Paginationmini :pageConfig="pageConfig3" @currentPage="currentChange5" @pageSize="pageSizeChange5"></Paginationmini>
                                            </div>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>志愿者电话</label>
                                            <el-input v-model="VolunteerPhone3"></el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="basic_info_right">
                                <div class="basic_title">配偶紧急联系人</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>姓名</label>
                                            <el-input v-model="form2.jtcyname3"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>关系</label>
                                            <el-input v-model="form2.jtcyrelation3"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>性别</label>
                                            <el-select v-model="form2.jtcysex3">
                                                 <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>年龄</label>
                                            <el-input v-model="form2.jtcyage3"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>民族</label>
                                            <el-input v-model="form2.jtcynation3"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="item_list clearfix">
                                    <label>身份证号</label>
                                    <el-input v-model="form2.jtcyidNumber3"></el-input>
                                </div>
                                <div class="item_list clearfix">
                                    <label>户口所在地</label>
                                    <el-input v-model="form2.jtcylocation3"></el-input>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系电话</label>
                                    <el-input v-model="form2.jtcyphone3"></el-input>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系地址</label>
                                    <el-input v-model="form2.jtcyaddress3"></el-input>
                                </div>
                            </div>
                        </div>
                        <div class="basic_info_3">
                            <div class="basic_info_left">
                                <div class="basic_title direct">直系亲属紧急联系人</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>姓名</label>
                                            <el-input v-model="form2.jtcyname2"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>关系</label>
                                            <el-input v-model="form2.jtcyrelation2"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>性别</label>
                                            <el-select v-model="form2.jtcysex2">
                                                <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>联系电话</label>
                                            <el-input v-model="form2.jtcyphone2"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>备用电话</label>
                                            <el-input v-model="form2.jtcybyphone2"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系地址</label>
                                    <el-input v-model="form.jtcy_address2"></el-input>
                                </div>
                            </div>
                            <div class="basic_info_right">
                                <div class="basic_title urgent">紧急联系人</div>
                                <div class="basic_item">
                                    <div class="item_left">
                                        <div class="avatar-uploader"><i class="avatar-uploader-icon"></i></div>
                                        <div style="display:none;">
                                            <input @change="fileChange1" id="dictUpload1" type="file" />
                                        </div>
                                        <label for="dictUpload1" class="up__speech">
                                            <span class="up__speech-txt">选择文件</span>
                                        </label>
                                    </div>
                                    <div class="item_right">
                                        <div class="item_list clearfix">
                                            <label>姓名</label>
                                            <el-input v-model="form2.jtcyname1"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>关系</label>
                                            <el-input v-model="form2.jtcyrelation1"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>性别</label>
                                            <el-select v-model="form2.jtcysex1">
                                               <el-option label="男" value="1">男</el-option>
                                                <el-option label="女" value="2">女</el-option>
                                            </el-select>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>联系电话</label>
                                            <el-input v-model="form2.jtcyphone1"></el-input>
                                        </div>
                                        <div class="item_list clearfix">
                                            <label>备用电话</label>
                                            <el-input v-model="form2.jtcybyphone1"></el-input>
                                        </div>
                                    </div>
                                </div>
                                <div class="item_list clearfix">
                                    <label>联系地址</label>
                                    <el-input v-model="form2.jtcyaddress1"></el-input>
                                </div>

                            </div>
                        </div>
                        <div class="basic_info_4">
                            <div class="basic_title">操作历史记录</div>
                            <div class="basic_info4_left">
                                <div class="item_left">
                                    <div class="item_list clearfix">
                                        <label>登记时间</label>
                                        <el-input v-model="form.entrytime"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>签约时间</label>
                                        <el-input v-model="form.qianyuetime"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>注销时间</label>
                                        <el-input v-model="form.zhuxiaotime"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>信息取消时间</label>
                                        <el-input v-model="form.isDeaddate"></el-input>
                                    </div>
                                </div>
                                <div class="item_left">
                                    <div class="item_list clearfix">
                                        <label>登记人</label>
                                        <el-input v-model="form.addperson"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>签约人</label>
                                        <el-input v-model="form.qianyueperson"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>注销人</label>
                                        <el-input v-model="form.zhuxiaoperson"></el-input>
                                    </div>
                                    <div class="item_list clearfix">
                                        <label>实体取消时间</label>
                                        <el-input v-model="form.isFreedate"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <el-button type="primary" class="saveBtn" @click="saveBtn('form')">保存</el-button>
                     </el-form>
                    </div>
                </el-tab-pane>
                  <el-tab-pane label="健康信息" name="2">
                    <div class="fl health-right">
                        <el-form ref="form" :model="form" :inline="true" label-width="90px">

                            <div class="form-div basic_info_1 basic_info_health basic_info_history">
                                <el-form-item label="病史">
                                    <el-checkbox-group v-model="disease">
                                        <el-checkbox label="0">健康</el-checkbox>
                                        <el-checkbox label="1">高血压</el-checkbox>
                                        <el-checkbox label="2">糖尿病</el-checkbox>
                                        <el-checkbox label="3">冠心病</el-checkbox>
                                        <el-checkbox label="4">恶性肿瘤</el-checkbox>
                                        <el-checkbox label="5">结核病</el-checkbox>
                                        <el-checkbox label="6">肝炎</el-checkbox>
                                        <el-checkbox label="7">脑卒中</el-checkbox>
                                        <el-checkbox label="8">精神疾病</el-checkbox>
                                        <el-checkbox label="9">慢性阻塞性肺疾病</el-checkbox>
                                        <el-checkbox label="11">慢性支气管炎</el-checkbox>
                                        <el-checkbox label="12">帕金森综合症 </el-checkbox>
                                        <el-checkbox label="13">腰椎间盘突出</el-checkbox>
                                        <el-checkbox label="14">阿尔茨海默病</el-checkbox>
                                        <el-checkbox label="15">心脏病</el-checkbox>
                                        <el-checkbox label="16">肺气肿</el-checkbox>
                                        <el-checkbox label="17">白内障</el-checkbox>
                                        <el-checkbox label="18">脑血栓</el-checkbox>
                                        <el-checkbox label="19">风湿病</el-checkbox>
                                        <el-checkbox label="20">脑中风</el-checkbox>
                                        <el-checkbox label="21">高脂血症 </el-checkbox>
                                        <el-checkbox label="22">哮喘</el-checkbox>
                                        <el-checkbox label="23">意外伤害</el-checkbox>
                                        <div>
                                             <el-checkbox label="10">其他</el-checkbox>
                                            <el-input class='vm' style='width: auto;margin: -10px 0 0 10px;' v-model="form.diseaseOther"></el-input>
                                        </div>
                                    </el-checkbox-group>

                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <p class="clearfix"></p>
                    <el-form ref="form" :model="form" :inline="true" label-width="130px">
                        <div class="form-div">
                            <el-form-item label="老人自理类别">
                                <el-checkbox-group v-model="specialCommunity">
                                    <el-checkbox label="0">自理</el-checkbox>
                                    <el-checkbox label="1">失能</el-checkbox>
                                    <el-checkbox label="2">半失能</el-checkbox>
                                    <el-checkbox label="3">失智</el-checkbox>
                                    <el-checkbox label="6">轻度依赖</el-checkbox>
                                    <el-checkbox label="7">重度依赖</el-checkbox>
                                    <el-checkbox label="8">不能自理</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                        <el-row>
                        <el-col :span="12">
                            <div class="form-div">
                                <el-form-item label="经常服用药物">
                                    <el-input v-model="form.yaowu" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-div">
                                <el-form-item label="备注">
                                    <el-input v-model="form.oldremark" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="form-div">
                                <el-form-item label="听力状况">
                                    <el-checkbox-group v-model="tingCommunity">
                                        <el-checkbox label="1">良好</el-checkbox>
                                        <el-checkbox label="2">一般</el-checkbox>
                                        <el-checkbox label="3">很大声才能听见</el-checkbox>
                                        <el-checkbox label="4">听不见</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </div>

                            <div class="form-div">
                                <el-form-item label="药物过敏情况">
                                    <el-input v-model="form.guoming" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>

                            <div class="form-div">
                                <el-form-item label="绑定设备(IMEI)">
                                    <el-input v-model="form.imei" :rows="2" type="text"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        </el-row>
                    </el-form>
                    <h3 class="basic_title">健康记录</h3>
                    <el-table class="sms-table"
                        :data="tableData"
                        stripe
                        tooltip-effect="dark"
                        @selection-change="handleSelectionChange"
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="心率"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="idcard"
                            show-overflow-tooltip
                            label="血压低压">
                        </el-table-column>
                        <el-table-column
                            prop="code"
                            show-overflow-tooltip
                            label="血压高压">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="血糖">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="上传时间">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="数据来源">
                        </el-table-column>
                    </el-table>
                    <!-- 分页开始  -->
                    <Pagination :pageConfig="pageConfig3" @currentPage="currentChange6" @pageSize="pageSizeChange6"></Pagination>
                    <el-button type="primary" class="saveBtn" @click="saveBtn('form')">保存</el-button>
                </el-tab-pane>
                 <el-tab-pane label="政府援助信息" name="3">
                    <div class="basic_title">享受的服务信息</div>
                	<el-form ref="form" class="form-service" :model="form6" :inline="true" label-width="180px">
                        <div class="clearfix">
                            <div class='fl form-tab'>
                                <div class="form-div">
                                     <el-form-item  label="服务类型" prop="isDead">
                                        <el-checkbox-group v-model="form.isDead">
                                            <el-checkbox label="信息服务"></el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                    <el-form-item prop="isFree">
                                        <el-checkbox-group v-model="form.isFree">
                                        <el-checkbox label="实体服务"></el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="用户手机套餐">
                                        <el-select placeholder="请选择" v-model="form6.mobileMenuid">
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="用户享受的服务类别">
                                        <el-select placeholder="请选择" v-model="form6.customerTypeid">
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class='fl form-tab'>
                                <div class="form-div">
                                    <el-form-item label="服务状态">
                                        <el-select placeholder="请选择" v-model="form.states">
                                            <el-option label="待签约" value="1"></el-option>
                                            <el-option label="在用" value="2"></el-option>
                                            <el-option label="注销" value="4"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="用户手机型号">
                                        <el-select placeholder="请选择" v-model="form.phoneModelid">
                                            <el-option label="全部" value="shanghai"></el-option>
                                            <el-option label="1" value="beijing"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-div">
                                    <el-form-item label="政府援助次数">
                                        <el-input v-model="form.freeCount"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>

                        <div class="form-div form-textarea">
                            <el-form-item label="状态变更原因">
                                <el-input placeholder="请输入" type="textarea" v-model="form.statesChgRsn"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-div form-textarea">
                            <el-form-item label="审核拒绝原因">
                                <el-input type="textarea" v-model="form.statesjujue"></el-input>
                            </el-form-item>
                        </div>
					    <p><br /></p>
                        <el-button type="primary" class="saveBtn" @click="saveBtn('form')">保存</el-button>

                	</el-form>

                </el-tab-pane>
                  <el-tab-pane label="历史回复" name="4">
                    <el-table class="sms-table"
                        :data="tableData"
                        stripe
                        tooltip-effect="dark"
                        @selection-change="handleSelectionChange"
                        style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="时间"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="idcard"
                            show-overflow-tooltip
                            label="回复类型">
                        </el-table-column>
                        <el-table-column
                            prop="code"
                            show-overflow-tooltip
                            label="回访需求">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="通话记录">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="回访流程">
                        </el-table-column>
                        <el-table-column
                            prop="company"
                            show-overflow-tooltip
                            label="数据来源">
                        </el-table-column>
                    </el-table>
                    <!-- 分页开始  -->
                    <Pagination :pageConfig="pageConfig3" @currentPage="currentChange7" @pageSize="pageSizeChange7"></Pagination>
                </el-tab-pane>
                <el-tab-pane label="客户电子账户" name="5"></el-tab-pane>
                <el-tab-pane label="兴康管家信息" name="6"></el-tab-pane>
                <el-tab-pane label="客户地理位置" name="7"></el-tab-pane>
            </el-tabs>
        </div>
    </el-col>
</el-row>
</template>

<script>
import {metaDataMgrDao} from '@/api/dao.js'
import Paginationmini  from  '../add/pagination-mini'
export default {
    data() {
         var checkUserName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户名不能为空'));
            }else{
                callback();
            }
        };
         var checkIdNumber = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('身份证号不能为空'));
            }else{
                callback();
            }
        };
        var checkType = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户类型不能为空'));
            }else{
                callback();
            }
        };
         var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号码不能为空'));
            }else{
                callback();
            }
        };
        var checkAddressId= (rule, value, callback) => {
            if (!value) {
                return callback(new Error('区域选择不能为空'));
            }else{
                callback();
            }
        };
        var checkAddress= (rule, value, callback) => {
            if (!value) {
                return callback(new Error('详细地址不能为空'));
            }else{
                callback();
            }
        };
        var checkCurrertAddress= (rule, value, callback) => {
            if (!value) {
                return callback(new Error('当前地址不能为空'));
            }else{
                callback();
            }
        };
        return {
            param: new FormData(),
            count:0,
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            imageUrl:'',
            imagePath:'',
            tableExpand:false,
            tableExpand2:false,
            tableExpand3:false,
            activeName : '1',
            tableData:[],
            checkList1:[''],
            checkList2:[''],
            checkList3:[''],
            checkList4:[''],
            minzhengIndex:[''],
            government:[''],
            pattern:[''],
            desiredService:[''],
            governmentTarget:[''],
            economicSource:[''],
            certificateType:[''],
            personalHobby:[''],
            options:[],
            shi:'',
            qu:'',
            jd:'',
            sq:'',
            volunteer1Name:'',
            VolunteerPhone1:'',
            volunteer2Name:'',
            VolunteerPhone2:'',
            volunteer3Name:'',
            VolunteerPhone3:'',
            belongAddressIds:'',

            form: {
                 addressId:'',
                    city:'',
                    zone:'',
                    street:'',
                    shequ:'',
                    name:'',
                    sex:'',
                    idNumber:'',
                    age:'',
                    address:'',
                    birthday:'',
                    community:'',
                    familyphone:'',
                    moreinfo:'',
                    phone:'',
                    states:'0',
                    type:'',
                    communityId:'',
                    addperson:'',
                    entrytime:'',
                    qianyueperson:'',
                    qianyuetime:'',
                    zhuxiaoperson:'',
                    zhuxiaotime:'',
                    currentAddress:'',
                    lifeAreas:'',
                    marriageStatus:'',
                    volunteerida:'',
                    volunteeridb:'',
                    volunteeridc:'',
                    age:'',
                    isDeaddate:'',
                    isFreedate:'',
                    certificateNumber:'',
                    economicSource:'',
                    minzhengIndex:'',
                    certificateType:'',
                    otherCertificateType:'',
                    otherEconomicSource:'',
                    otherMinzhengIndex:'',
                    otherPersonalHobby:'',
                    personalHobby:'',
                    postTitle:'',
                    object:'',
                    disease:'',
                    diseaseOther:'',
                     specialCommunity:'',
                   // tingCommunity:'',
                    //isDead: '',
                    //isFree: '',
                   // mobileMenuid: '',
                    //freeCount: '',
                   // statesChgRsn: '',
                   // statesjujue: '',
                    belongAddressId:'',
                    points:0,
             },
             form2:{
                    jtcyaddress1:'',
                    jtcyaddress2:'',
                    jtcyname1:'',
                    jtcyname2:'',
                    jtcyphone1:'',
                    jtcyphone2:'',
                    jtcyrelation1:'',
                    jtcyrelation2:'',
                    ischegnshisanwu:'',
                    government:'',
                    governmentTarget:'',
                    jtcyaddress3:'',
                    jtcyage3:'',
                    jtcyage2:'',
                    jtcybyphone1:'',
                    jtcybyphone2:'',
                    jtcyidNumber3:'',
                    jtcylocation3:'',
                    jtcyname3:'',
                    jtcynation3:'',
                    jtcyphone3:'',
                    jtcyrelation3:'',
                    jtcysex1:'',
                    jtcysex2:'',
                    jtcysex3:'',
                    otherPattern:'',
                    pattern:'',

            },
             //健康信息
             disease:[''],
             specialCommunity:[''],
             juzhuCommunity:[''],

             tingCommunity:[''],
            form6: {

            },
            rules2: {
                   name: [
                        { validator: checkUserName, trigger: 'blur' }
                    ],
                   phone: [
                        { validator: checkPhone, trigger: 'blur' }
                    ],
                   idNumber: [
                        { validator: checkIdNumber, trigger: 'blur' }
                    ],
                    type: [
                        { validator: checkType, trigger: 'blur' }
                    ],
                    addressId: [
                        { validator: checkAddressId, trigger: 'blur' }
                    ],
                     address:[
                        { validator: checkAddress, trigger: 'blur' }
                    ],
                    currentAddress:[
                        {validator: checkCurrertAddress, trigger:'blur'}
                    ],
            },
             pageConfig3: {
                pageSize: 6,
                total: 0,
                pageNo: 1
            },
        };
    },
    methods: {
         selectAddressName(){

                if(this.belongAddressIds!=null&&this.belongAddressIds!=''){
                    var formData = new FormData();

                    formData.append("id",this.belongAddressIds)
                    metaDataMgrDao.findCityInfoById(formData).then(resp=>{
                    if(resp.code="200"){
                    this.options=[];
                    console.log(resp);
                    let list =  resp.content;
                    this.options = this.options.concat(list)
                    }
                    this.tableLoading = false;
                    console.log(resp);
                })
                }else{
                    metaDataMgrDao.findCityInfo().then(resp=>{
                    if(resp.code="200"){
                    this.options=[];
                    console.log(resp);
                    let list =  resp.content.list;

                    this.options = this.options.concat(list)
                    }
                    this.tableLoading = false;
                    console.log(resp);
                })
                }

        },
        changeValue(vaule){
            this.form.addressId=value;
        },
         handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
         },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
        OnChange(file,fileList){
            this.fileList=fileList;
        },
        OnRemove(file,fileList){
            this.fileList=fileList
        },
         findIdNumber(e) {
            var idNumber=e.target.value;
           	if(idNumber!=null && idNumber!=""){
                var age=(new Date().getFullYear()) - (idNumber.substring(6, 10));
                this.form.age=age;
                var birthday = idNumber.substring(6, 10) + "-"+ idNumber.substring(10, 12) + "-" + idNumber.substring(12, 14);
                this.form.birthday=birthday;
                if (parseInt(idNumber.substr(16, 1)) % 2 == 0) {
                   this.form.sex="2";

                } else {
                  this.form.sex="1";
                }
			}else{
				return null;
            }

        },
       inputClick(){
            this.tableExpand = true;
            var formData = new FormData();
            formData.append("pageNo",this.pageConfig3.pageNo)
            formData.append("pageSize",this.pageConfig3.pageSize)
             formData.append("belongAddressId",this.belongAddressIds)
            metaDataMgrDao.getVolunteer(formData).then(resp=>{
            if(resp.code="200"){
                if(resp.content!=null){
                        console.log(resp);
                        this.tableData=[];
                        let list =  resp.content.list;
                        let currentPageNo = resp.content.pageNo;
                        let currentFirstIndex = (currentPageNo-1)*this.pageConfig3.pageSize+1;
                        for(let o of list) {
                        o.index = currentFirstIndex;
                        o.key = currentFirstIndex;
                        currentFirstIndex++;
                    }
                        this.pageConfig3.total= resp.content.count;
                        this.tableData = this.tableData.concat(list)
                }else{
                        console.log(resp);
                        this.tableData=[];
                        var count =0;
                        this.pageConfig3.total= count;
                }

            }else{
                this.tableData = this.tableData.concat(null)
            }
            this.tableLoading = false;
            console.log(resp);
            })
        },
        currentChange3(currentPage) {
            this.pageConfig3.pageNo =  currentPage
            this.inputClick()
        },
        pageSizeChange3(size) {
            this.pageConfig3.pageSize = size
        },
        inputClosekVolunteer1(){
            this.tableExpand = false;
        },
        changeVolunteer1(id){
             this.tableExpand = false;
             var formData = new FormData();
             formData.append("id",id)

             metaDataMgrDao.findVolunteerId(formData).then(resp=>{
                if(resp.code=200){
                   console.log(resp);
                    let obj =  resp.content
                    this.volunteer1Name=obj.name;
                    this.VolunteerPhone1=obj.telephone;

                }
                this.form.volunteerida=id;
                console.log(resp);
            })
        },
         inputClick2(){
            this.tableExpand2 = true;
            var formData = new FormData();
            formData.append("pageNo",this.pageConfig3.pageNo)
            formData.append("pageSize",this.pageConfig3.pageSize)
              formData.append("belongAddressId",this.belongAddressIds)
            metaDataMgrDao.getVolunteer(formData).then(resp=>{
            if(resp.code="200"){
                if(resp.content!=null){
                        console.log(resp);
                        this.tableData=[];
                        let list =  resp.content.list;
                        let currentPageNo = resp.content.pageNo;
                        let currentFirstIndex = (currentPageNo-1)*this.pageConfig3.pageSize+1;
                        for(let o of list) {
                        o.index = currentFirstIndex;
                        o.key = currentFirstIndex;
                        currentFirstIndex++;
                    }
                        this.pageConfig3.total= resp.content.count;
                        this.tableData = this.tableData.concat(list)
                }else{
                        console.log(resp);
                        this.tableData=[];
                        var count =0;
                        this.pageConfig3.total= count;
                }

            }else{
                this.tableData = this.tableData.concat(null)
            }
            this.tableLoading = false;
            console.log(resp);
            })
        },
        currentChange4(currentPage) {
            this.pageConfig3.pageNo =  currentPage
            this.inputClick2()
        },
        pageSizeChange4(size) {
            this.pageConfig3.pageSize = size
        },
        inputClosekVolunteer2(){
            this.tableExpand2 = false;
        },
        changeVolunteer2(id){
             this.tableExpand2 = false;
             var formData = new FormData();
             formData.append("id",id)
             metaDataMgrDao.findVolunteerId(formData).then(resp=>{
                if(resp.code="200"){
                   console.log(resp);
                    let obj =  resp.content
                    this.volunteer2Name=obj.name;
                    this.VolunteerPhone2=obj.telephone;

                }
                this.form.volunteeridb=id;
                console.log(resp);
            })
        },
         inputClick3(){
            this.tableExpand3 = true;
            var formData = new FormData();
            formData.append("pageNo",this.pageConfig3.pageNo)
            formData.append("pageSize",this.pageConfig3.pageSize)
              formData.append("belongAddressId",this.belongAddressIds)
            metaDataMgrDao.getVolunteer(formData).then(resp=>{
            if(resp.code="200"){
                if(resp.content!=null){
                        console.log(resp);
                        this.tableData=[];
                        let list =  resp.content.list;
                        let currentPageNo = resp.content.pageNo;
                        let currentFirstIndex = (currentPageNo-1)*this.pageConfig3.pageSize+1;
                        for(let o of list) {
                        o.index = currentFirstIndex;
                        o.key = currentFirstIndex;
                        currentFirstIndex++;
                    }
                        this.pageConfig3.total= resp.content.count;
                        this.tableData = this.tableData.concat(list)
                }else{
                        console.log(resp);
                        this.tableData=[];
                        var count =0;
                        this.pageConfig3.total= count;
                }

            }else{
                this.tableData = this.tableData.concat(null)
            }
            this.tableLoading = false;
            console.log(resp);
            })
        },
        currentChange5(currentPage) {
            this.pageConfig3.pageNo =  currentPage
            this.inputClick3()
        },
        pageSizeChange5(size) {
            this.pageConfig3.pageSize = size
        },
        inputClosekVolunteer3(){
            this.tableExpand3 = false;
        },
        changeVolunteer3(id){
             this.tableExpand3 = false;
             var formData = new FormData();
             formData.append("id",id)
             metaDataMgrDao.findVolunteerId(formData).then(resp=>{
                if(resp.code="200"){
                   console.log(resp);
                    let obj =  resp.content
                    this.volunteer3Name=obj.name;
                    this.VolunteerPhone3=obj.telephone;

                }
                this.form.volunteeridc=id;
                console.log(resp);
            })
        },
      saveBtn(formName){
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.form.minzhengIndex=this.minzhengIndex.join(",");
                this.form2.government=this.government.join(",");
                this.form2.pattern=this.pattern.join(",");
                this.form2.desiredService=this.desiredService.join(",");

                this.form2.governmentTarget=this.governmentTarget.join(",");
                this.form.economicSource=this.economicSource.join(",");
                this.form.certificateType=this.certificateType.join(",");
                this.form.personalHobby=this.personalHobby.join(",");
               // this.form.disease=this.disease.join(",");
               // this.form.specialCommunity=this.specialCommunity.join(",");
                //this.form.tingCommunity=this.tingCommunity.join(",");
                if(this.belongAddressIds!=null&&this.belongAddressIds!=''){
                    this.form.belongAddressId=this.belongAddressIds;
                }else{
                    this.form.belongAddressId=this.form.addressId
                }
                this.form.communityId=this.sq;
                this.form.object=JSON.stringify(this.form2);
                console.log(this.form.object)
                var params=JSON.stringify(this.form);
                console.log(params);
                //let file=''
                //for(let x in this.form){
                //this.param.append(x,this.form[x])
               // }
               // for(let i=0;i<this.fileList.length;i++){
               // file='file'+this.count
               // this.count++
               // this.param.append(file,this.fileList[i].raw)
              // }

                const loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)',
                            target: document.querySelector('.div1')
                        });
                    setTimeout(() => {
                            loading.close();
                    }, 2000);
                metaDataMgrDao.addCustomer(params).then(resp =>{
                            if(resp.code=="200"){
                                this.$alert("提交成功", '提交结果', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    callback: action => {
                                        this.$emit('closeAddCuster',true)
                                    },
                                });
                            }
                            else{
                                this.$alert("提交失败", '提交结果', {
                                    confirmButtonText: '确定',
                                    type: 'warning',
                                    callback: action => {

                                    },
                                });
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
        },
         //地址查询
       selectAddressShi(){
             var formData = new FormData();
             formData.append("addressType","1")
            formData.append("belongAddressId",this.belongAddressIds)
             metaDataMgrDao.findAddressById(formData).then(resp=>{
                if(resp.code="200"){
                    this.options=[];
                   console.log(resp);
                    let list =  resp.content.list;

                   this.options = this.options.concat(list)
                }
                this.tableLoading = false;
                console.log(resp);
            })
        },
      changeValue(value){
           this.shi=value;
        },
      selectAddressQu(){
             var formData = new FormData();
             formData.append("id",this.shi)
             metaDataMgrDao.findAddressById(formData).then(resp=>{
                if(resp.code="200"){
                    this.options=[];
                   console.log(resp);
                    let list =  resp.content.list;

                   this.options = this.options.concat(list)
                }
                this.tableLoading = false;
                console.log(resp);
            })
        },
        quValue(value){
          this.qu=value;
        },
        selectAddressJd(){
            var formData = new FormData();
             formData.append("id",this.qu)
             metaDataMgrDao.findAddressById(formData).then(resp=>{
                if(resp.code="200"){
                    this.options=[];
                   console.log(resp);
                    let list =  resp.content.list;

                   this.options = this.options.concat(list)
                }
                this.tableLoading = false;
                console.log(resp);
            })
        },
        jdValue(value){
          this.jd=value;
        },
        selectAddressSq(){
            var formData = new FormData();
             formData.append("id",this.jd)
             metaDataMgrDao.findAddressById(formData).then(resp=>{
                if(resp.code="200"){
                    this.options=[];
                   console.log(resp);
                    let list =  resp.content.list;

                   this.options = this.options.concat(list)
                }
                this.tableLoading = false;
                console.log(resp);
            })
        },
        sqValue(value){
          this.sq=value;
        },
       currentChange6(currentPage) {
            this.pageConfig3.pageNo =  currentPage

        },
        pageSizeChange6(size) {
            this.pageConfig3.pageSize = size
        },
        currentChange7(currentPage) {
            this.pageConfig3.pageNo =  currentPage

        },
        pageSizeChange7(size) {
            this.pageConfig3.pageSize = size
        },
        //tab切换
        handleClick(){

        },
        fileChange1(){

        },
        fileChange2(){

        },
        close(){
            this.$emit('closeAddCuster',true)
        }
    },
    mounted : function(){
          if(sessionStorage.getItem("user")){
          var a=sessionStorage.getItem("user");
           this.belongAddressIds=a;
           console.log( this.belongAddressIds)
          };
    },
    components: { Paginationmini }
}
</script>

<style lang="less">
.avatar-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.add_info_title{
    height:40px;
    line-height:40px;
    font-size:24px;
    .info_btn{
        float:right;
    }
}
.basic_info{
    display:flex;
}
.up__speech{
    background: #5a9ad0;
    color: #fff;
    border-radius: 3px;
    width: 178px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    margin-top: 10px;
}
.basic_info_div1{
    background: #d7d9db;
    flex: 1;
    margin-left: 10px;
}
.add_infoDiv {
    .form-div .el-form-item{
        width:auto !important;
    }
    .basic_info_1{
        .el-form-item__label{
            font-size: 16px;
        }
        .el-form-item__content{
            display:flex;
            .el-input{
                width:25%;
            }
        }
        .el-checkbox-group{
            margin:0 10px;
        }
        .form-label {
            .el-form-item__label{
                width:140px!important;
            }
            .el-input{
                width:100%;
            }
        }
        .form-like{
            width:100%!important;
            .el-form-item__content{
                width:100%;
            }
        }
        .form-input{
            .el-input{
                width:100%;
            }
        }
        .form-flex{
            .el-form-item{
                flex:1;
                .el-form-item__content,.el-input{
                    width:100%;
                }

            }

        }
    }
}
.basic_info_2{
    border-bottom:1px solid #ccc;
}
.basic_title{
    font-size:20px;
    color:#4f94cd;
    margin: 20px auto;
    position:relative;
    padding-left: 10px
}
.direct{
    color:#ff9000;
}
.urgent{
    color:#ff4343;
}
.basic_title::before{
    content:"";
    width:3px;
    height: 24px;
    background: #4f94cd;
    position: absolute;
    left: 0;
    top: 2px;
}
.basic_title.urgent::before{
    background:#ff4343;
}
.basic_title.direct::before{
    background:#ff9000;
}
.basic_info_3{
    display:flex;
    .basic_info_left,.basic_info_right{
        width:50%;
        flex:1;
    }
    .basic_item{
        display:flex;
    }
    .item_left{
        margin-bottom:10px;
    }
    .avatar-uploader{
        width:140px;
        height:140px;
        background:#d7d9db;
    }
    .up__speech{
        width:140px;
    }
    .item_right{
        margin-left:20px;
        flex:1;
        margin-right:20px;
    }
}
.item_list{
    margin:20px 0;
    label{
        width:90px;
        padding-right:10px;
        text-align:right;
        display:inline-block;
        line-height:30px;
        float:left;
    }
    .el-select{
        width:72%;
        float:left;
        .el-input{
            width:100%;
        }
    }
    .el-input{
        width:72%;
        float:left;
    }
}
.basic_info_4{
    border-top:1px solid #ccc;
}
.basic_info4_left{
    display:flex;
    .item_left{
        width:50%;
    }
}
.saveBtn{
    width:50%;
    margin:0 auto;
    display: inherit;
    margin-bottom: 30px;
}
</style>
